import ServiceIcon4 from '../../Icons/Home-page/ServiceIcon4';
import ServiceIcon10 from '../../Icons/Home-page/ServiceIcon10';
import ServiceIcon13 from '../../Icons/Home-page/ServiceIcon13';
import ServiceIcon14 from '../../Icons/Home-page/ServiceIcon14';

export const allPrograms = [
    {
        icon : <ServiceIcon13 />,
        name: 'إطعام مسكين'
    },
    {
        icon : <ServiceIcon4 />,
        name: 'إخراج زكاة'
    },
    {
        icon : <ServiceIcon14 />,
        name: 'صدقة'
    },
    {
        icon : <ServiceIcon10 />,
        name: 'أضحية'
    },
]